<div class="border rounded-lg flex-1 bg-white shadow-sm">
  <ng-container *ngIf="tieneConceptos; else sinConceptos">
    <div class="overflow-y-auto h-[45vh]">
      <table class="w-full text-xs divide-y divide-gray-200">
        <thead class="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
          <tr>
            <th class="h-8 px-2 text-left font-medium text-gray-600 w-[60px]">Código</th>
            <th class="h-8 px-2 text-left font-medium text-gray-600 w-[180px]">Descripción</th>
            <th class="h-8 px-2 text-right font-medium text-gray-600 w-[90px]">Importe S/IVA</th>
            <th class="h-8 px-2 text-right font-medium text-gray-600 w-[70px]">% IVA</th>
            <th class="h-8 px-2 text-right font-medium text-gray-600 w-[90px]">Total C/IVA</th>
            <th class="h-8 px-2 text-center font-medium text-gray-600 w-[80px]">Cuenta</th>
            <th class="h-8 px-2 text-left font-medium text-gray-600 w-[150px]">Observaciones</th>
            <th class="h-8 px-2 text-left font-medium text-gray-600 w-[130px]">CENCO</th>
            <th class="h-8 px-2 text-right font-medium text-gray-600 w-[90px]">Precedencia</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-100">
          @for (c of conceptos;track getOrderKey(c)) {
          <tr class="hover:bg-gray-50 transition-colors">
            <td class="px-2 py-1.5">{{ c.codi_concep }}</td>
            <td class="px-2 py-1.5">{{ c.descrip_concep }}</td>

            <td class="px-2 py-1.5">
              <input type="number" 
                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                [(ngModel)]="c.impor_editable" 
                (ngModelChange)="validarImporte(c)" 
                min="0" 
                [max]="c.impor_pend" />
            </td>

            <td class="px-2 py-1.5">
              <input type="number" 
                class="w-full text-right px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                [(ngModel)]="c.porcen_iva_editable" 
                (ngModelChange)="validarIva(c)" 
                min="0" />
            </td>

            <td class="px-2 py-1.5 text-right font-medium text-gray-900">
              {{
              (c.impor_editable ?? 0) * (1 + (c.porcen_iva_editable ?? 0) / 100)
              | currency:'ARS':'' : '1.2-2' : 'es-AR'
              }}
            </td>

            <td class="px-2 py-1.5 text-center text-gray-600">
              {{ c.cuenta_concep }}
            </td>

            <td class="px-2 py-1.5" [attr.title]="c.observaciones">
              <div class="flex items-center gap-1">
                @if(c.observaciones){
                <span class="truncate">{{ c.observaciones }}</span>
                }@else{
                <span class="text-gray-400 italic">Sin asignar</span>
                }

                <button class="p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-full transition-colors"
                  (click)="abrirModalObservaciones(c)" 
                  matTooltip="Editar Observaciones">
                  <mat-icon class="text-[18px]">edit_note</mat-icon>
                </button>
              </div>
            </td>

            <td class="px-2 py-1.5">
              <div class="flex items-center gap-1">
                <ng-container *ngIf="!c.CODI_CENCO; else conCenco">
                  <span class="text-gray-400 italic">Sin asignar</span>
                  <button class="p-1 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-full transition-colors"
                    (click)="seleccionarCenco(c)" 
                    matTooltip="Seleccionar Centro De Costos">
                    <mat-icon class="text-[18px]">request_quote</mat-icon>
                  </button>
                </ng-container>

                <ng-template #conCenco>
                  <span class="font-medium text-gray-700" [attr.title]="c.CODI_CENCO">{{c.descrip_cenco}}</span>
                  <button class="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors"
                    (click)="eliminarCenco(c)"
                    matTooltip="Eliminar Centro De Costos">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" 
                      stroke="currentColor" class="w-4 h-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </ng-template>
              </div>
            </td>

            <td class="px-2 py-1.5 text-right text-gray-600">{{ c.TIPO }} - {{ c.NUM }} - {{ c.renglon }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="border-t bg-gray-50">
      <table class="w-full text-xs">
        <tbody>
          <tr>
            <td class="px-2 py-3 w-[60px]"></td>
            <td class="px-2 py-3 text-right font-medium text-gray-700 w-[180px]">TOTAL S/IVA</td>
            <td class="px-2 py-3 text-right font-medium text-gray-900 w-[90px]">
              {{monedaTotal}} {{ obtenerTotalSinIvas() | currency:'ARS':'' : '1.2-2' : 'es-AR' }}
            </td>
            <td class="px-2 py-3 text-right font-medium text-gray-700 w-[70px]">TOTAL C/IVA</td>
            <td class="px-2 py-3 text-right font-medium text-gray-900 w-[90px]">
              {{monedaTotal}} {{ obtenerTotalConIvas() | currency:'ARS':'' : '1.2-2' : 'es-AR' }}
            </td>
            <td class="px-2 py-3 w-[80px]"></td>
            <td class="px-2 py-3 w-[150px]"></td>
            <td class="px-2 py-3 w-[100px]"></td>
            <td class="px-2 py-3 w-[90px]"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #sinConceptos>
    <div class="p-4 text-center">
      <p class="text-gray-500">
        No hay conceptos seleccionados para esta factura.
      </p>
    </div>
  </ng-template>
</div>